import { Suspense } from "react"
import { useTranslation } from "react-i18next"

import { Customers } from "@/components/customers"
import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"

export function CustomersPage() {
  const { t } = useTranslation()

  return (
    <Suspense fallback={<div>{t("common.loading")}</div>}>
      <DashboardContainer>
        <Header>
          <AppBreadcrumb
            links={[
              {
                href: FRONTEND_ROUTES.DASHBOARD.href,
                label: t("sidebar.dashboard"),
              },
              {
                label: t("sidebar.customers"),
              },
            ]}
          />
        </Header>
        <section className="flex min-w-0 flex-1 flex-col gap-4 overflow-hidden p-4 @container">
          <h1 className="page-title">
            {t("pages.customers.title")}
          </h1>
          <Customers />
        </section>
      </DashboardContainer>
    </Suspense>
  )
}
